export default "__VITE_ASSET__cOE5epTS__"